<script setup>

import {
  always, cond, equals, isEmpty, multiply,
} from 'ramda';
import { computed } from 'vue';

const props = defineProps({
  price: {
    required: true,
  },
  sign: {
    required: false,
    default: '',
  },
  type: {
    required: false,
    default: 'money',
  },
});

const currencyByType = computed(() => cond([
  [equals('money'), always('€')],
  [equals('percent'), always('%')],
])(props.type));

const finalPrice = computed(() => Math.round(props.price * 100) / 100);

</script>

<template>
  <span>
    <span v-if="!isEmpty(sign)">{{ sign }} </span>
    {{ finalPrice }} {{ currencyByType }}
  </span>
</template>
